import { Button, Card, CircularProgress, TextField, Typography } from '@material-ui/core';
import { CropFree } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useCallback, useState } from 'react';
import { QrCodeScannerDialog } from './qr-code-scanner-dialog';

const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  card: {
    padding: theme.spacing(3, 2.5),
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  qrButton: {
    height: 48,
    marginBottom: theme.spacing(1.5),
  },
  searchButton: {
    height: 48,
    fontWeight: 'bold',
  },
}));

export function SearchStep({ testCode, onTestCodeChange, onSearch, searching }) {
  const classes = useStyles();
  const [qrScannerOpen, setQrScannerOpen] = useState(false);

  const handleQrScan = useCallback((code) => {
    setQrScannerOpen(false);
    onTestCodeChange(code);
  }, [onTestCodeChange]);

  const handleQrScannerClose = useCallback(() => setQrScannerOpen(false), []);

  return (
    <>
      <Typography variant="body2" className={classes.subtitle}>
        Informe o código impresso na avaliação do aluno para lançar o gabarito.
      </Typography>
      <Card className={classes.card}>
        <TextField
          className={classes.field}
          label="Código da Avaliação"
          placeholder="Ex: 4F82A1"
          value={testCode}
          onChange={(evt) => onTestCodeChange(evt.target.value)}
          onKeyDown={(evt) => { if (evt.key === 'Enter') onSearch(); }}
          fullWidth
          autoFocus
          variant="outlined"
          inputProps={{ autoCapitalize: 'characters', autoComplete: 'off' }}
          disabled={searching}
        />
        <Button
          className={classes.qrButton}
          variant="outlined"
          color="primary"
          fullWidth
          onClick={() => setQrScannerOpen(true)}
          disabled={searching}
          startIcon={<CropFree />}
        >
          Ler QR Code
        </Button>
        <Button
          className={classes.searchButton}
          variant="contained"
          color="primary"
          fullWidth
          onClick={onSearch}
          disabled={!testCode.trim() || searching}
          startIcon={searching ? <CircularProgress size={18} color="inherit" /> : null}
        >
          Buscar Avaliação
        </Button>
      </Card>
      <QrCodeScannerDialog
        open={qrScannerOpen}
        onClose={handleQrScannerClose}
        onScan={handleQrScan}
      />
    </>
  );
}
